import { useParams } from 'react-router';
import { useDefaultSurveyQuery } from '../../../../domain/Surveys/query';

export type SurveyIdStatus = 'Found' | 'NotFound' | 'Fetching' | 'Default';

type NotFoundSurveyIdData = {
  surveyId: undefined;
  status: 'NotFound';
  isSurveyIdLoaded: true;
};

type FetchingSurveyIdData = {
  surveyId: undefined;
  status: 'Fetching';
  isSurveyIdLoaded: false;
};

type UndefinedSurveyIdData = NotFoundSurveyIdData | FetchingSurveyIdData;

type DefinedSurveyIdData = {
  surveyId: number;
  status: 'Found' | 'Default';
  isSurveyIdLoaded: true;
};

type CurrentSurveyIdData = UndefinedSurveyIdData | DefinedSurveyIdData;

export const useCurrentSurveyId = (siteId: number | undefined): CurrentSurveyIdData => {
  const { surveyId: surveyIdParam } = useParams();

  const { data: defaultSurvey, isFetching: isDefaultSurveyFetching } = useDefaultSurveyQuery(
    siteId,
    surveyIdParam === undefined,
  );

  if (surveyIdParam !== undefined) {
    return { surveyId: Number(surveyIdParam), status: 'Found', isSurveyIdLoaded: true };
  }

  if (isDefaultSurveyFetching) {
    return { surveyId: undefined, status: 'Fetching', isSurveyIdLoaded: false };
  }

  if (defaultSurvey === undefined) {
    return { surveyId: undefined, status: 'NotFound', isSurveyIdLoaded: true };
  }

  return { surveyId: defaultSurvey.id, status: 'Default', isSurveyIdLoaded: true };
};
